import React, { useState } from "react";
import Modal from "react-responsive-modal";
import { useNavigate } from "react-router-dom";
import useResponsive from "../../customHooks/useResponsive";
import Otp from "../Otp";
import axios from "axios";
import toast from "react-hot-toast";
import { app_url } from "../../config";
import { AiOutlineClose } from "react-icons/ai";

const BuyNewBulkAvailable = ({
  open,
  onClose,
  existingPackageId,
  changeTabOnOtpVerification,
  packageName,
  quantity,
  count,
  setCount,
}) => {
  const [response, setResponse] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [userDetails, setUserDetais] = useState({
    firstname: "",
    lastname: "",
    mobileNo: "",
    email: "",
    city: "",
    country: "",
    state: "",
  });
  const [networkErr, setNetworkErr] = useState(navigator.onLine);
  const [isLoading, setIsLoading] = useState(false);

  const { email, mobileNo, city, country, firstname, lastname, state } =
    userDetails;

  console.log(quantity, "quantity check");
  console.log(count, "count check");

  const token = JSON.parse(localStorage.getItem("etijwaal-agent"))?.token;
  const { width } = useResponsive();
  const navigate = useNavigate();

  const increment = () => {
    if (count < quantity) {
      setCount((prevCount) => prevCount + 1);
      console.log("increment");
    }
  };

  const decrement = () => {
    if (count > 1) {
      setCount((prevCount) => prevCount - 1);
    }
  };

  function emptyUserDetailsAfterOtpVerification() {
    setUserDetais({
      firstname: "",
      lastname: "",
      city: "",
      country: "",
      email: "",
      mobileNo: "",
      state: "",
    });
  }

  function otpVerified() {
    setResponse(false);
  }

  function submitForm(e) {
    e.preventDefault();
    if (
      !email ||
      !mobileNo ||
      !city ||
      !country ||
      !firstname ||
      !lastname ||
      !state
    ) {
      toast.error("Enter missing fields!");
      return;
    }
    setIsLoading(true);
    axios
      .post(
        `${app_url}/api/customer/registerAndAssignBulkEsimToCustomerPartner_v2`,
        {
          first_name: firstname,
          last_name: lastname,
          email: email,
          mobile: `${countryCode}${mobileNo}`,
          city: city,
          state: state,
          country: country,
          packageId: existingPackageId,
          quantity: count,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        toast.success(res.data?.message);
        onClose();
        changeTabOnOtpVerification();
        otpVerified();
        emptyUserDetailsAfterOtpVerification();
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate("/");
        } else if (err.response?.status === 400) {
          toast.error(err.response?.data.message);
          setIsLoading(false);
        } else {
          setNetworkErr(navigator.onLine);
          toast.error(err.response?.data.message);
          setIsLoading(false);
        }
      });
  }

  return (
    <Modal
      open={open}
      styles={{
        modal: {
          padding: "1.5em 1em",
          width: width < 840 ? "90%" : "100%",
          margin: "0 auto",
          borderRadius: "4px 4px 4px",
        },
      }}
      onClose={onClose}
      showCloseIcon={!networkErr}
      center
    >
      <a
        href="#"
        data-bs-dismiss="modal"
        aria-label="Close"
        className="text-decoration-none text-dark"
        style={{ fontSize: "1.5rem", display: "flex", justifyContent: "end" }}
        onClick={() => {
          onClose();
          setResponse(false);
          setUserDetais({
            mobileNo: "",
          });
        }}
      >
        <AiOutlineClose />
      </a>
      <div className="flex flex-wrap sm:flex-nowrap text-center sm:text-start justify-center sm:justify-normal items-center mb-6 gap-2">
        <img
          src="/assets/esim.png"
          className="sm:w-[50px] sm:h-[50px] w-[80px] h-[80px]"
          alt="esims"
        />
        <div className="flex justify-center sm:justify-between w-full">
          <div>
            <p>{packageName}</p>
            <h2 className="text-lg  sm:text-2xl text-gray-600 font-semibold">
              Available Quantity: {quantity}
            </h2>
            <div className="flex gap-2 bg-red-500 text-white shadow px-2 mt-2 rounded items-center">
              <h2>Assign</h2>
              <div className="flex items-center gap-4">
                <button
                  onClick={decrement}
                  className="text-xl font-bold cursor-pointer hover:scale-150 transition-all duration-500 rounded"
                >
                  -
                </button>

                <div className="w-[109px] h-[40px] flex items-center text-black justify-center shadow bg-gray-50 font-bold">
                  {count}
                </div>
                <button
                  onClick={increment}
                  className="text-xl font-bold cursor-pointer hover:scale-150 transition-all duration-500 rounded"
                >
                  +
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="relative">
        <form onSubmit={submitForm} className="max-w-full">
          <div className="grid md:grid-cols-2 md:gap-6">
            <div className="relative z-0 w-full mb-5 group">
              <input
                autoComplete="false"
                disabled={response}
                onChange={(e) =>
                  setUserDetais({
                    ...userDetails,
                    firstname: e.target.value,
                  })
                }
                type="text"
                name="floating_first_name"
                id="floating_first_name"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder="First Name"
                required
              />
              {/* <label
                for="floating_first_name"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 z-0 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                First name
              </label> */}
            </div>
            <div className="relative z-0 w-full mb-5 group">
              <input
                autoComplete="false"
                disabled={response}
                type="text"
                onChange={(e) =>
                  setUserDetais({
                    ...userDetails,
                    lastname: e.target.value,
                  })
                }
                name="floating_last_name"
                id="floating_last_name"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder="Last Name"
                required
              />
              {/* <label
                for="floating_last_name"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 z-0 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Last name
              </label> */}
            </div>
          </div>
          <div className="grid md:grid-cols-2 md:gap-6">
            <div className="relative z-0 w-full mb-5 group">
              <input
                autoComplete="false"
                disabled={response}
                type="email"
                onChange={(e) =>
                  setUserDetais({ ...userDetails, email: e.target.value })
                }
                name="floating_email"
                id="floating_email"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder="Email"
                required
              />
              {/* <label
                for="floating_email"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 z-0 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Email
              </label> */}
            </div>

            <div className="relative z-0 flex items-end gap-3 w-full mb-5 group">
              {/* <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select your country code</label> */}
              <div className="w-[40%]">
                <select
                  id="countries"
                  onChange={(e) => setCountryCode(e.target.value)}
                  className="border-b-2 border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-1 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  name="countrycode"
                >
                  <option value="" hidden="">
                    Code
                  </option>
                  <option value="93">Afghanistan (+93)</option>
                  <option value="358">Aland Islands (+358)</option>
                  <option value="355">Albania (+355)</option>
                  <option value="213">Algeria (+213)</option>
                  <option value="1684">AmericanSamoa (+1684)</option>
                  <option value="376">Andorra (+376)</option>
                  <option value="244">Angola (+244)</option>
                  <option value="1264">Anguilla (+1264)</option>
                  <option value="672">Antarctica (+672)</option>
                  <option value="1268">Antigua and Barbuda (+1268)</option>
                  <option value="54">Argentina (+54)</option>
                  <option value="374">Armenia (+374)</option>
                  <option value="297">Aruba (+297)</option>
                  <option value="61">Australia (+61)</option>
                  <option value="43">Austria (+43)</option>
                  <option value="994">Azerbaijan (+994)</option>
                  <option value="1242">Bahamas (+1242)</option>
                  <option value="973">Bahrain (+973)</option>
                  <option value="880">Bangladesh (+880)</option>
                  <option value="1246">Barbados (+1246)</option>
                  <option value="375">Belarus (+375)</option>
                  <option value="32">Belgium (+32)</option>
                  <option value="501">Belize (+501)</option>
                  <option value="229">Benin (+229)</option>
                  <option value="1441">Bermuda (+1441)</option>
                  <option value="975">Bhutan (+975)</option>
                  <option value="591">
                    Bolivia, Plurinational State of (+591)
                  </option>
                  <option value="387">Bosnia and Herzegovina (+387)</option>
                  <option value="267">Botswana (+267)</option>
                  <option value="55">Brazil (+55)</option>
                  <option value="246">
                    British Indian Ocean Territory (+246)
                  </option>
                  <option value="673">Brunei Darussalam (+673)</option>
                  <option value="359">Bulgaria (+359)</option>
                  <option value="226">Burkina Faso (+226)</option>
                  <option value="257">Burundi (+257)</option>
                  <option value="855">Cambodia (+855)</option>
                  <option value="237">Cameroon (+237)</option>
                  <option value="1">Canada (+1)</option>
                  <option value="238">Cape Verde (+238)</option>
                  <option value="345">Cayman Islands (+345)</option>
                  <option value="236">Central African Republic (+236)</option>
                  <option value="235">Chad (+235)</option>
                  <option value="56">Chile (+56)</option>
                  <option value="86">China (+86)</option>
                  <option value="61">Christmas Island (+61)</option>
                  <option value="61">Cocos (Keeling) Islands (+61)</option>
                  <option value="57">Colombia (+57)</option>
                  <option value="269">Comoros (+269)</option>
                  <option value="242">Congo (+242)</option>
                  <option value="243">
                    Congo, The Democratic Republic of the Congo (+243)
                  </option>
                  <option value="682">Cook Islands (+682)</option>
                  <option value="506">Costa Rica (+506)</option>
                  <option value="225">Cote d'Ivoire (+225)</option>
                  <option value="385">Croatia (+385)</option>
                  <option value="53">Cuba (+53)</option>
                  <option value="357">Cyprus (+357)</option>
                  <option value="420">Czech Republic (+420)</option>
                  <option value="45">Denmark (+45)</option>
                  <option value="253">Djibouti (+253)</option>
                  <option value="1767">Dominica (+1767)</option>
                  <option value="1849">Dominican Republic (+1849)</option>
                  <option value="593">Ecuador (+593)</option>
                  <option value="20">Egypt (+20)</option>
                  <option value="503">El Salvador (+503)</option>
                  <option value="240">Equatorial Guinea (+240)</option>
                  <option value="291">Eritrea (+291)</option>
                  <option value="372">Estonia (+372)</option>
                  <option value="251">Ethiopia (+251)</option>
                  <option value="500">
                    Falkland Islands (Malvinas) (+500)
                  </option>
                  <option value="298">Faroe Islands (+298)</option>
                  <option value="679">Fiji (+679)</option>
                  <option value="358">Finland (+358)</option>
                  <option value="33">France (+33)</option>
                  <option value="594">French Guiana (+594)</option>
                  <option value="689">French Polynesia (+689)</option>
                  <option value="241">Gabon (+241)</option>
                  <option value="220">Gambia (+220)</option>
                  <option value="995">Georgia (+995)</option>
                  <option value="49">Germany (+49)</option>
                  <option value="233">Ghana (+233)</option>
                  <option value="350">Gibraltar (+350)</option>
                  <option value="30">Greece (+30)</option>
                  <option value="299">Greenland (+299)</option>
                  <option value="1473">Grenada (+1473)</option>
                  <option value="590">Guadeloupe (+590)</option>
                  <option value="1671">Guam (+1671)</option>
                  <option value="502">Guatemala (+502)</option>
                  <option value="44">Guernsey (+44)</option>
                  <option value="224">Guinea (+224)</option>
                  <option value="245">Guinea-Bissau (+245)</option>
                  <option value="595">Guyana (+595)</option>
                  <option value="509">Haiti (+509)</option>
                  <option value="379">
                    Holy See (Vatican City State) (+379)
                  </option>
                  <option value="504">Honduras (+504)</option>
                  <option value="852">Hong Kong (+852)</option>
                  <option value="36">Hungary (+36)</option>
                  <option value="354">Iceland (+354)</option>
                  <option value="91">India (+91)</option>
                  <option value="62">Indonesia (+62)</option>
                  <option value="98">
                    Iran, Islamic Republic of Persian Gulf (+98)
                  </option>
                  <option value="964">Iraq (+964)</option>
                  <option value="353">Ireland (+353)</option>
                  <option value="44">Isle of Man (+44)</option>
                  <option value="972">Israel (+972)</option>
                  <option value="39">Italy (+39)</option>
                  <option value="1876">Jamaica (+1876)</option>
                  <option value="81">Japan (+81)</option>
                  <option value="44">Jersey (+44)</option>
                  <option value="962">Jordan (+962)</option>
                  <option value="77">Kazakhstan (+77)</option>
                  <option value="254">Kenya (+254)</option>
                  <option value="686">Kiribati (+686)</option>
                  <option value="850">
                    Korea, Democratic People's Republic of Korea (+850)
                  </option>
                  <option value="82">
                    Korea, Republic of South Korea (+82)
                  </option>
                  <option value="965">Kuwait (+965)</option>
                  <option value="996">Kyrgyzstan (+996)</option>
                  <option value="856">Laos (+856)</option>
                  <option value="371">Latvia (+371)</option>
                  <option value="961">Lebanon (+961)</option>
                  <option value="266">Lesotho (+266)</option>
                  <option value="231">Liberia (+231)</option>
                  <option value="218">Libyan Arab Jamahiriya (+218)</option>
                  <option value="423">Liechtenstein (+423)</option>
                  <option value="370">Lithuania (+370)</option>
                  <option value="352">Luxembourg (+352)</option>
                  <option value="853">Macao (+853)</option>
                  <option value="389">Macedonia (+389)</option>
                  <option value="261">Madagascar (+261)</option>
                  <option value="265">Malawi (+265)</option>
                  <option value="60">Malaysia (+60)</option>
                  <option value="960">Maldives (+960)</option>
                  <option value="223">Mali (+223)</option>
                  <option value="356">Malta (+356)</option>
                  <option value="692">Marshall Islands (+692)</option>
                  <option value="596">Martinique (+596)</option>
                  <option value="222">Mauritania (+222)</option>
                  <option value="230">Mauritius (+230)</option>
                  <option value="262">Mayotte (+262)</option>
                  <option value="52">Mexico (+52)</option>
                  <option value="691">
                    Micronesia, Federated States of Micronesia (+691)
                  </option>
                  <option value="373">Moldova (+373)</option>
                  <option value="377">Monaco (+377)</option>
                  <option value="976">Mongolia (+976)</option>
                  <option value="382">Montenegro (+382)</option>
                  <option value="1664">Montserrat (+1664)</option>
                  <option value="212">Morocco (+212)</option>
                  <option value="258">Mozambique (+258)</option>
                  <option value="95">Myanmar (+95)</option>
                  <option value="264">Namibia (+264)</option>
                  <option value="674">Nauru (+674)</option>
                  <option value="977">Nepal (+977)</option>
                  <option value="31">Netherlands (+31)</option>
                  <option value="599">Netherlands Antilles (+599)</option>
                  <option value="687">New Caledonia (+687)</option>
                  <option value="64">New Zealand (+64)</option>
                  <option value="505">Nicaragua (+505)</option>
                  <option value="227">Niger (+227)</option>
                  <option value="234">Nigeria (+234)</option>
                  <option value="683">Niue (+683)</option>
                  <option value="672">Norfolk Island (+672)</option>
                  <option value="1670">Northern Mariana Islands (+1670)</option>
                  <option value="47">Norway (+47)</option>
                  <option value="968">Oman (+968)</option>
                  <option value="92">Pakistan (+92)</option>
                  <option value="680">Palau (+680)</option>
                  <option value="970">
                    Palestinian Territory, Occupied (+970)
                  </option>
                  <option value="507">Panama (+507)</option>
                  <option value="675">Papua New Guinea (+675)</option>
                  <option value="595">Paraguay (+595)</option>
                  <option value="51">Peru (+51)</option>
                  <option value="63">Philippines (+63)</option>
                  <option value="872">Pitcairn (+872)</option>
                  <option value="48">Poland (+48)</option>
                  <option value="351">Portugal (+351)</option>
                  <option value="1939">Puerto Rico (+1939)</option>
                  <option value="974">Qatar (+974)</option>
                  <option value="40">Romania (+40)</option>
                  <option value="7">Russia (+7)</option>
                  <option value="250">Rwanda (+250)</option>
                  <option value="262">Reunion (+262)</option>
                  <option value="590">Saint Barthelemy (+590)</option>
                  <option value="290">
                    Saint Helena, Ascension and Tristan Da Cunha (+290)
                  </option>
                  <option value="1869">Saint Kitts and Nevis (+1869)</option>
                  <option value="1758">Saint Lucia (+1758)</option>
                  <option value="590">Saint Martin (+590)</option>
                  <option value="508">Saint Pierre and Miquelon (+508)</option>
                  <option value="1784">
                    Saint Vincent and the Grenadines (+1784)
                  </option>
                  <option value="685">Samoa (+685)</option>
                  <option value="378">San Marino (+378)</option>
                  <option value="239">Sao Tome and Principe (+239)</option>
                  <option value="966">Saudi Arabia (+966)</option>
                  <option value="221">Senegal (+221)</option>
                  <option value="381">Serbia (+381)</option>
                  <option value="248">Seychelles (+248)</option>
                  <option value="232">Sierra Leone (+232)</option>
                  <option value="65">Singapore (+65)</option>
                  <option value="421">Slovakia (+421)</option>
                  <option value="386">Slovenia (+386)</option>
                  <option value="677">Solomon Islands (+677)</option>
                  <option value="252">Somalia (+252)</option>
                  <option value="27">South Africa (+27)</option>
                  <option value="211">South Sudan (+211)</option>
                  <option value="500">
                    South Georgia and the South Sandwich Islands (+500)
                  </option>
                  <option value="34">Spain (+34)</option>
                  <option value="94">Sri Lanka (+94)</option>
                  <option value="249">Sudan (+249)</option>
                  <option value="597">Suriname (+597)</option>
                  <option value="47">Svalbard and Jan Mayen (+47)</option>
                  <option value="268">Swaziland (+268)</option>
                  <option value="46">Sweden (+46)</option>
                  <option value="41">Switzerland (+41)</option>
                  <option value="963">Syrian Arab Republic (+963)</option>
                  <option value="886">Taiwan (+886)</option>
                  <option value="992">Tajikistan (+992)</option>
                  <option value="255">
                    Tanzania, United Republic of Tanzania (+255)
                  </option>
                  <option value="66">Thailand (+66)</option>
                  <option value="670">Timor-Leste (+670)</option>
                  <option value="228">Togo (+228)</option>
                  <option value="690">Tokelau (+690)</option>
                  <option value="676">Tonga (+676)</option>
                  <option value="1868">Trinidad and Tobago (+1868)</option>
                  <option value="216">Tunisia (+216)</option>
                  <option value="90">Turkey (+90)</option>
                  <option value="993">Turkmenistan (+993)</option>
                  <option value="1649">Turks and Caicos Islands (+1649)</option>
                  <option value="688">Tuvalu (+688)</option>
                  <option value="256">Uganda (+256)</option>
                  <option value="380">Ukraine (+380)</option>
                  <option value="971">United Arab Emirates (+971)</option>
                  <option value="44">United Kingdom (+44)</option>
                  <option value="1">United States (+1)</option>
                  <option value="598">Uruguay (+598)</option>
                  <option value="998">Uzbekistan (+998)</option>
                  <option value="678">Vanuatu (+678)</option>
                  <option value="58">
                    Venezuela, Bolivarian Republic of Venezuela (+58)
                  </option>
                  <option value="84">Vietnam (+84)</option>
                  <option value="1284">Virgin Islands, British (+1284)</option>
                  <option value="1340">Virgin Islands, U.S. (+1340)</option>
                  <option value="681">Wallis and Futuna (+681)</option>
                  <option value="967">Yemen (+967)</option>
                  <option value="260">Zambia (+260)</option>
                  <option value="263">Zimbabwe (+263)</option>
                  {/* <option value="93">Afghanistan +93</option><option value="355">Albania +355</option><option value="213">Algeria +213</option><option selected value="1">American +1</option><option value="376">Andorra +376</option><option value="244">Angola +244</option><option value="1">Anguilla +1</option><option value="1">Antigua +1</option><option value="54">Argentina +54</option><option value="374">Armenia +374</option><option value="297">Aruba +297</option><option value="61">Australia +61</option><option value="43">Austria +43</option><option value="358">Aland +358</option><option value="994">Azerbaijan +994</option><option value="1">Bahamas +1</option><option value="973">Bahrain +973</option><option value="880">Bangladesh +880</option><option value="1">Barbados +1</option><option value="375">Belarus +375</option><option value="32">Belgium +32</option><option value="501">Belize +501</option><option value="229">Benin +229</option><option value="1">Bermuda +1</option><option value="975">Bhutan +975</option><option value="591">Bolivia +591</option><option value="387">Bosnia +387</option><option value="267">Botswana +267</option><option value="55">Brazil +55</option><option value="673">Brunei +673</option><option value="359">Bulgaria +359</option><option value="226">Burkina +226</option><option value="257">Burundi +257</option><option value="855">Cambodia +855</option><option value="237">Cameroon +237</option><option value="1">Canada +1</option><option value="238">Cape +238</option><option value="1">Cayman +1</option><option value="236">Central +236</option><option value="235">Chad +235</option><option value="56">Chile +56</option><option value="86">China +86</option><option value="61">Christmas +61</option><option value="61">Cocos +61</option><option value="57">Colombia +57</option><option value="269">Comoros +269</option><option value="242">Congo +242</option><option value="682">Cook +682</option><option value="506">Costa +506</option><option value="385">Croatia +385</option><option value="53">Cuba +53</option><option value="357">Cyprus +357</option><option value="420">Czech +420</option><option value="45">Denmark +45</option><option value="253">Djibouti +253</option><option value="1">Dominica +1</option><option value="1">Dominican +1</option><option value="593">Ecuador +593</option><option value="20">Egypt +20</option><option value="503">El +503</option><option value="240">Equatorial +240</option><option value="291">Eritrea +291</option><option value="372">Estonia +372</option><option value="251">Ethiopia +251</option><option value="500">Falkland +500</option><option value="298">Faroe +298</option><option value="679">Fiji +679</option><option value="358">Finland +358</option><option value="33">France +33</option><option value="262">French +262</option><option value="241">Gabon +241</option><option value="220">Gambia +220</option><option value="995">Georgia +995</option><option value="49">Germany +49</option><option value="233">Ghana +233</option><option value="350">Gibraltar +350</option><option value="30">Greece +30</option><option value="299">Greenland +299</option><option value="1">Grenada +1</option><option value="590">Guadeloupe +590</option><option value="1">Guam +1</option><option value="502">Guatemala +502</option><option value="224">Guinea +224</option><option value="592">Guyana +592</option><option value="509">Haiti +509</option><option value="379">Holy +379</option><option value="852">Hong +852</option><option value="504">Honduras +504</option><option value="36">Hungary +36</option><option value="354">Iceland +354</option><option value="91">India +91</option><option value="62">Indonesia +62</option><option value="98">Iran +98</option><option value="964">Iraq +964</option><option value="353">Ireland +353</option><option value="972">Israel +972</option><option value="39">Italy +39</option><option value="225">Côte +225</option><option value="1">Jamaica +1</option><option value="81">Japan +81</option><option value="962">Jordan +962</option><option value="7">Kazakhstan +7</option><option value="254">Kenya +254</option><option value="686">Kiribati +686</option><option value="82">Korea +82</option><option value="965">Kuwait +965</option><option value="996">Kyrgyzstan +996</option><option value="856">Lao +856</option><option value="371">Latvia +371</option><option value="961">Lebanon +961</option><option value="266">Lesotho +266</option><option value="231">Liberia +231</option><option value="218">Libyan +218</option><option value="423">Liechtenstein +423</option><option value="370">Lithuania +370</option><option value="352">Luxembourg +352</option><option value="853">Macao +853</option><option value="389">North +389</option><option value="261">Madagascar +261</option><option value="265">Malawi +265</option><option value="60">Malaysia +60</option><option value="960">Maldives +960</option><option value="223">Mali +223</option><option value="356">Malta +356</option><option value="692">Marshall +692</option><option value="596">Martinique +596</option><option value="222">Mauritania +222</option><option value="230">Mauritius +230</option><option value="262">Mayotte +262</option><option value="52">Mexico +52</option><option value="691">Micronesia +691</option><option value="373">Moldova +373</option><option value="377">Monaco +377</option><option value="976">Mongolia +976</option><option value="382">Montenegro +382</option><option value="1">Montserrat +1</option><option value="212">Morocco +212</option><option value="258">Mozambique +258</option><option value="95">Myanmar +95</option><option value="264">Namibia +264</option><option value="674">Nauru +674</option><option value="977">Nepal +977</option><option value="31">Netherlands +31</option><option value="687">New +687</option><option value="505">Nicaragua +505</option><option value="227">Niger +227</option><option value="234">Nigeria +234</option><option value="683">Niue +683</option><option value="672">Norfolk +672</option><option value="1">Northern +1</option><option value="47">Norway +47</option><option value="968">Oman +968</option><option value="92">Pakistan +92</option><option value="680">Palau +680</option><option value="970">Palestinian +970</option><option value="507">Panama +507</option><option value="675">Papua +675</option><option value="595">Paraguay +595</option><option value="51">Peru +51</option><option value="63">Philippines +63</option><option value="64">Pitcairn +64</option><option value="48">Poland +48</option><option value="351">Portugal +351</option><option value="1">Puerto +1</option><option value="974">Qatar +974</option><option value="40">Romania +40</option><option value="7">Russian +7</option><option value="250">Rwanda +250</option><option value="262">Réunion +262</option><option value="590">Saint +590</option><option value="685">Samoa +685</option><option value="378">San +378</option><option value="239">Sao +239</option><option value="966">Saudi +966</option><option value="221">Senegal +221</option><option value="381">Serbia +381</option><option value="248">Seychelles +248</option><option value="232">Sierra +232</option><option value="65">Singapore +65</option><option value="421">Slovakia +421</option><option value="386">Slovenia +386</option><option value="677">Solomon +677</option><option value="252">Somalia +252</option><option value="27">South +27</option><option value="34">Spain +34</option><option value="94">Sri +94</option><option value="249">Sudan +249</option><option value="597">Suriname +597</option><option value="47">Svalbard +47</option><option value="268">Swaziland +268</option><option value="46">Sweden +46</option><option value="41">Switzerland +41</option><option value="963">Syrian +963</option><option value="886">Taiwan +886</option><option value="992">Tajikistan +992</option><option value="255">Tanzania +255</option><option value="66">Thailand +66</option><option value="670">Timor +670</option><option value="228">Togo +228</option><option value="690">Tokelau +690</option><option value="676">Tonga +676</option><option value="1">Trinidad +1</option><option value="216">Tunisia +216</option><option value="90">Turkey +90</option><option value="993">Turkmenistan +993</option><option value="1">Turks +1</option><option value="688">Tuvalu +688</option><option value="256">Uganda +256</option><option value="380">Ukraine +380</option><option value="971">United +971</option><option value="598">Uruguay +598</option><option value="998">Uzbekistan +998</option><option value="678">Vanuatu +678</option><option value="58">Venezuela +58</option><option value="84">Viet +84</option><option value="1">Virgin +1</option><option value="681">Wallis +681</option><option value="212">Western +212</option><option value="967">Yemen +967</option><option value="260">Zambia +260</option><option value="263">Zimbabwe +263</option> */}
                </select>
              </div>

              <div className="w-[70%]">
                <input
                  autoComplete="false"
                  maxLength={15}
                  disabled={response}
                  type="tel"
                  value={userDetails.mobileNo}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (/^[1-9][0-9]*$/.test(inputValue) || inputValue === "") {
                      setUserDetais({
                        ...userDetails,
                        mobileNo: inputValue,
                      });
                    }
                  }}
                  name="floating_phone"
                  id="floating_phone"
                  className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                  placeholder="Phone (123-456-7890)"
                  required
                />
                {/* <label
                  for="floating_phone"
                  className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 z-0 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Phone number {width < 400 ? "" : "(123-456-7890)"}{" "}
                </label> */}
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-2 md:gap-6">
            <div className="relative z-0 w-full mb-5 group">
              <input
                autoComplete="false"
                disabled={response}
                type="text"
                onChange={(e) =>
                  setUserDetais({ ...userDetails, city: e.target.value })
                }
                name="floating_city"
                id="floating_city"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder="City"
                required
              />
              {/* <label
                for="floating_company"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 z-0 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                City
              </label> */}
            </div>
            <div className="relative z-0 w-full mb-5 group">
              <input
                autoComplete="false"
                disabled={response}
                type="text"
                name="floating_state"
                id="floating_state"
                onChange={(e) =>
                  setUserDetais({ ...userDetails, state: e.target.value })
                }
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder="State"
                required
              />
              {/* <label
                for="floating_phone"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 z-0 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                State
              </label> */}
            </div>
          </div>
          <div className="grid md:grid-cols-2 md:gap-6 items-center">
            <div className="relative z-0 w-full mb-5 group">
              <input
                autoComplete="false"
                disabled={response}
                type="text"
                name="floating_country"
                onChange={(e) =>
                  setUserDetais({ ...userDetails, country: e.target.value })
                }
                id="floating_country"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder="Country"
                required
              />
              {/* <label
                for="floating_phone"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 z-0 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Country
              </label> */}
            </div>

            <div className="relative z-0 w-full  mb-5 group"></div>
          </div>

          <div>
            <div className="">
              {/* <button
                type="submit"
                disabled={isLoadingOpt}
                className={`${
                  response ? "hidden" : "block"
                } text-white bg-blue-700 flex items-center justify-center  hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
              >
                {isLoadingOpt ? "...loading" : "Submit"}
              </button> */}
              <ul style={{ listStyle: "inside" }}>
                <p className="font-bold">Note:</p>
                <li>Ensure all details are correct before submitting.</li>
                <li>
                  The email must be unique and accurate. If it's incorrect, the
                  customer will not receive their eSIM.
                </li>
                <li>Double-check the quantity assigned to the customer.</li>
              </ul>
              <button
                type="submit"
                disabled={isLoading}
                className="px-4 py-2 bg-green-600 rounded-lg text-white mt-4"
              >
                {isLoading ? "...loading" : "Register Customer and Assign eSim"}
              </button>
            </div>
          </div>
        </form>
        {/* <Otp
          email={email}
          mobile={userDetails.mobileNo}
          response={response}
          countryCode={countryCode}
          city={city}
          country={country}
          firstname={firstname}
          lastname={lastname}
          mobileNo={mobileNo}
          state={state}
          onClose={onClose}
          apiUrl={"registerAndAssignBulkEsimToCustomerPartner"}
          changeTabOnOtpVerification={changeTabOnOtpVerification}
          otpVerified={otpVerified}
          existingPackageId={existingPackageId}
          emptyUserDetailsAfterOtpVerification={
            emptyUserDetailsAfterOtpVerification
          }
          iccid={iccid}
          quantity={count}
        /> */}
        {/* <button
          type="button"
          onClick={() => {
            onClose();
            setResponse(false);
            setUserDetais({
              mobileNo: "",
            });
          }}
          className="my-custom-btn text-white absolute bottom-0 right-0 mb-0 ms-6 bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
        >
          Close
        </button> */}
      </section>
    </Modal>
  );
};

export default BuyNewBulkAvailable;
